// src/components/NotificationContainer.jsx
import React from 'react';
import { X, CheckCircle, AlertCircle, Info, AlertTriangle } from 'lucide-react';

const NotificationContainer = ({ notifications }) => {
    const getNotificationIcon = (type) => {
        switch (type) {
            case 'success':
                return <CheckCircle size={20} />;
            case 'error':
                return <AlertCircle size={20} />;
            case 'warning':
                return <AlertTriangle size={20} />;
            default:
                return <Info size={20} />;
        }
    };

    const getNotificationStyle = (type) => {
        const baseStyle = {
            padding: '12px 16px',
            borderRadius: '8px',
            marginBottom: '8px',
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            minWidth: '300px',
            maxWidth: '400px'
        };

        switch (type) {
            case 'success':
                return {
                    ...baseStyle,
                    backgroundColor: '#ecfdf5',
                    color: '#059669',
                    border: '1px solid #d1fae5'
                };
            case 'error':
                return {
                    ...baseStyle,
                    backgroundColor: '#fef2f2',
                    color: '#dc2626',
                    border: '1px solid #fecaca'
                };
            case 'warning':
                return {
                    ...baseStyle,
                    backgroundColor: '#fffbeb',
                    color: '#f59e0b',
                    border: '1px solid #fed7aa'
                };
            default:
                return {
                    ...baseStyle,
                    backgroundColor: '#eff6ff',
                    color: '#1e40af',
                    border: '1px solid #dbeafe'
                };
        }
    };

    if (!notifications || notifications.length === 0) {
        return null;
    }

    return (
        <div style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            gap: '8px'
        }}>
            {notifications.map((notification, index) => (
                <div
                    key={`${notification.id}-${index}`} // ✅ FIXED: Use both id and index
                    style={getNotificationStyle(notification.type)}
                >
                    {getNotificationIcon(notification.type)}
                    <span style={{ flex: 1, fontSize: '14px', fontWeight: '500' }}>
                        {notification.message}
                    </span>
                </div>
            ))}
        </div>
    );
};

export default NotificationContainer;